<template>
  <RequestWizard />
</template>

<script>
import { ANY } from '@ssi/vue-common/src/store/modules/pendingOps/getters';
import RequestWizard from '@/hrsa/components/requestWizard';

export default {
  components: { RequestWizard },

  beforeRouteLeave(to, from, next) {
    if (
      !this.$store.getters[`pendingOps/${ANY}`]
      // eslint-disable-next-line no-restricted-globals
      || confirm('Are you sure you want to leave? Changes you made may not be saved.')
    ) {
      next();
    } else {
      next(false);
    }
  }
};
</script>
